import React from 'react'

const Credit = () => {
  return (
    <div>Credit</div>
  )
}

export default Credit
